
define('text!modules/reporting/campaigns/siteTransparency/templates/chartLayout.html',[],function () { return '<div class="w-box w-Chart site-transparency-chart-panel"></div>\n';});

